import styled from 'styled-components';

import BaseInput from 'components/Input';

export const PhoneInput = styled(BaseInput)`
  overflow: visible;

  * > input {
    border-radius: 8px;
  }

  & > div {
    display: flex;
    flex-direction: row-reverse;
  }

  @media ${({ theme }) => theme.device.desktop} {
    * > input {
      font-size: 16px;
      height: 48px;
    }
  }
`;

export const CountryCodeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`;
